var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAuswertung = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 73,
  height: 74,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m54.603 46.358 15.649 16.12c2.33 2.334 2.33 6.225 0 8.67a5.955 5.955 0 0 1-8.435 0L46.391 55.252",
  stroke: "#CC0100",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M58.932 30.683c0 16.453-12.985 29.682-28.966 29.682C13.985 60.365 1 47.135 1 30.682S13.985 1 29.966 1c15.981 0 28.966 13.34 28.966 29.683Z",
  stroke: "#CC0100",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.547 30.794c0-3.224.666-6.226 1.776-8.894 1.11-2.78 2.774-5.225 4.772-7.337a20.855 20.855 0 0 1 7.103-4.892M15.54 39.131v5.892M22.752 33.795v11.228M29.965 24.902v20.121M37.18 28.014v17.01M44.395 18.01v27.013",
  stroke: "#CC0100",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgAuswertung;